var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcxeedLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9561 0.101685L24.2567 10.8962V0.101685H16.9561Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.48846 4.85408C6.6788 4.85408 7.70785 5.14727 8.57427 5.73499C9.4407 6.32271 10.0832 7.12998 10.5017 8.15816H16.1721C15.6283 5.61985 14.4326 3.60634 12.5851 2.11629C11.3055 1.08544 9.78727 0.420072 8.04242 0.102783H0.256592V11.2119C0.256592 9.28273 0.736449 7.74046 1.69751 6.58644C2.65858 5.43242 3.92223 4.85541 5.48846 4.85541",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57427 16.6556C7.70785 17.2433 6.6788 17.5365 5.48846 17.5365C3.92223 17.5365 2.65725 16.9648 1.69751 15.8215C0.736449 14.6782 0.256592 13.1413 0.256592 11.2108V22.3427H7.90779C9.70995 22.0348 11.2735 21.3547 12.5865 20.289C14.4353 18.7896 15.631 16.7801 16.1735 14.2619H10.5031C10.0845 15.2686 9.44203 16.0665 8.57561 16.6543",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2566 22.3427V10.8962L17.1799 22.3427H24.2566Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcxeedLogo);
export default __webpack_public_path__ + "static/media/icxeed-logo.014422c3f8ad5488c01bf88419a8c4e6.svg";
export { ForwardRef as ReactComponent };